export const apiRoutes = {
  login: "/auth/login",
  register: "/auth/register",
  forgotpassword: "/auth/forgot-password",
  businessSearch: "/business/search",
  addBusiness: "/business",
  getBusiness: "/business/get-business",
  deleteBusinessById: "/business",
  addHeatMapScan: "/heatmap/scan",
  heatmapHistory: "/heatmap/history",
  heatmapKeywordHistory: "/heatmap/keyword-history",
  pinHeatmap: "/heatmap/pin-heatmap",
  adminHeatmapKeywordHistory: "/admin/keyword-history",
  heatmapHistoryPagination: "/heatmap/history-paginated",
  deleteHeatmapHistory: "/heatmap/deleteHeatmap",
  reportHeatmap: "/heatmap/report",
  adminDashboard: "/admin/dashboard",
  adminDashboardNew: "/admin/dashboard-new",
  adminUserData: "/admin/user-data",
  adminUserPaginationData: "/admin/user-data-new",
  adminBusinessData: "/admin/business-data",
  adminBusinessPaginationData: "/admin/business-data-new",
  adminScanData: "/admin/scan-data",
  adminScanPaginationData: "/admin/scan-data-new",
  adminConfigurationData: "/admin/configuration-data",
  adminCtrsBoosterData: "/admin/ctrs",
  adminPlansData: "/admin/plans",
  health: "/get-health",
  heatmapGrid: "/heatmap/grid",
  getPlans: "/billing/get-plans",
  getConfiguration: "/heatmap/configuration",
  updateConfig: "/admin/configuration",
  billCheckout: "/billing/check-out",
  cancelSubscription: "/billing/cancel-subscription",
  billGetSession: "/billing/get-session",
  transactionHistory: "/user/transactions",
  creditHistory: "/user/credit-history",
  userProfile: "/user/profile",
  deleteAccountRequest: "/user/delete-account/request",
  deleteAccountConfirm: "/user/delete-account/confirm",
  publicShareReport: "/public/public-report",
  adminSettings: "/admin/settings",
  editHeatmap: "/heatmap/edit-heatmap",
  updatePlan: "/admin/edit-plan",
  updateAddonPlan: "/admin/edit-addon",
  deleteHistory: "/heatmap/delete-history",
  creditBillCheckout: "/billing/purchase-credit",
  creditBillGetSession: "/billing/confirm-credit-purchase",
  userKeys: "/user/keys",
  getAdminManagerData: "/admin/manager/data",
  addAdminBusiness: "/admin/add-business",
  adminBusinessSearch: "/business/search",
  adminLogin: "/auth/admin-login",
  adminAddHeatmapScan: "/admin/scan-heatmap",
  adminHeatmapHistory: "/admin/heatmap-history",
  adminHeatmapHistoryPagination: "/admin/heatmap-history-paginated",
  getAdminHeatmapGrid: "/admin/get-grid",
  adminReportHeatmap: "/admin/get-report",
  addGbp: "/business/add-gbp",
  getGbp: "/business/get-gbp",
  getGbpPaginated: "/business/get-gbp-paginated",
  resetPassword: "/auth/reset-password",
  resetEmployeepassword: "/checkin-business/update-employee-password",
  refreshReport: "/heatmap/refresh",
  adminRefreshReport: "/admin/refresh",
  getAdminManagerList: "/admin/list-managers",
  addAdminManager: "/admin/add-manager",
  deleteManager: "/admin/delete-manager",
  publicReport: "/public/report",
  createPublicReport: "/public/create-public-report",
  publicCase: "/public/case",
  businessExport: "/business/export",
  getCTRPurchase: "/addon/ctr-purchase",
  confirmCTRPurchase: "/addon/confirm-ctr-purchase",
  addonCTRForm: "/addon/ctr-form",
  addonGetCTRForm: "/addon/get-ctr-form",
  addonMapCheckInPurchase: "/addon/map-checkin-purchase",
  addonConfirmMapCheckInPurchase: "/addon/confirm-map-checkin-purchase",
  adminManageAddon: "/admin/manage-addon",
  adminDisableAddon: "/admin/disable-addon",
  adminUserToggleStatus: "/admin/toggle-user-status",
  adminToggleReselling: "/admin/toggle-reselling",
  adminGBPBusiness: "/admin/checkin/business",
  adminGBPBusinessPagination: "/admin/checkin/business-new",
  adminHeatmapDelete: "/admin/delete-heatmap",
  adminEditHeatmap: "/admin/edit-heatmap",
  adminGBPBusinessEnable: "/admin/checkin/enable-checkin",
  adminTransferAccount: "/admin/checkin/transfer",
  currentuser: "/public/type",
  addscans: "/admin/add-scans",
  addcredit: "/admin/add-credits",
  addAiCredit: "/admin/checkin/add-business-credits",
  // mapchecinaddbgp: "/checkin-business/add-gbp-business",
  mapcheckingetgbp: "/checkin-business/get-business",
  checkinBusinessPaginated: "/checkin-business/get-business-paginated",
  checkinBusinessSimplified: "/checkin-business/get-business-simplified",
  mapcheckingetgbpbusinessdetails: "/checkin-business/get-business-details",
  subscribegbp: "/addon/checkin-purchase",
  confirmpayment: "/addon/confirm-checkin-purchase",
  addonDetails: "/checkin-business/addon-details",
  createNativeSubscription: "/checkin-business/create-native-subscription",
  getteams: "/checkin-business/get-employees",
  employeePaginated: "/checkin-business/get-employees-paginated",
  getHeatmap: "/heatmap/get-heatmap",
  getAdminHeatmap: "/admin/get-heatmap",
  mapcheckingedashboard: "/checkin-business/dashboard",
  uploadLogo: "/checkin-business/upload-logo",
  uploadmomentassets: "/checkin/upload-moment-asset",
  editMapChekInForm: "/checkin-business/edit-checkin-business",
  getIntegration: "/checkin-business/get-integrations",
  addEmployee: "/checkin-business/add-employee",
  verifyEmployee: "/checkin-business/verify-employee",
  editEmployee: "/checkin-business/edit-employee",
  addIntegration: "/checkin-business/add-integrations",
  getcategories: "/checkin-business/categories",
  createcategories: "/checkin-business/add-category",
  deletecategories: "/checkin-business/delete-category",
  blockMember: "/checkin-business/toggle-block",
  moderationMember: "checkin-business/toggle-moderation",
  addWidget: "/checkin-widget/add-widget",
  editWidget: "/checkin-widget/edit-widget",
  editMapWidget: "/checkin-widget/edit-map-widget",
  // getWidget: "/widget",
  getWidgets: "/checkin-widget/get-widgets",
  deleteWidget: "/checkin-widget",
  copyWidget: "/checkin-widget/copy-widget",
  createMoment: "/checkin/create-moment",
  getWidgetData: "/checkin-widget/get-widget-data",
  getWidgetPins: "/checkin-widget/get-widget-pins",
  getWidgetList: "/checkin-widget/get-widget-list",
  getWidgetDetail: "/checkin-widget/get-widget-detail",
  getWidgetLocalities: "/checkin-widget/get-widget-localities",
  searchAddress: "/business/search-address",
  placeDetails: "/business/place-details",
  getCalendarPost: "/checkin/get-post",
  enhanceDescription: "/checkin/enhance-description",
  generatePostDescription: "/checkin/generate-post-description",
  reSchedulePost: "/checkin/reschedule-post",
  editPost: "/checkin/edit-post",
  connectFacebookPage: "/checkin-business/connect-facebook-page",
  connectInstagramPage: "/checkin-business/connect-instagram-page",
  connectInstagramPortfolio: "/checkin-business/connect-instagram-portfolio",
  intigration: "/checkin-business/integrate-social-media",
  removeIntegration: "/checkin-business/remove-integration",
  enablechekinpro: "/admin/checkin/toggle-map-checkin",
  editGBPPost: "/checkin/edit-gbp-post",
  editFacebookPost: "/checkin/edit-facebook-post",
  editInstagramPost: "/checkin/edit-instagram-post",
  editWebsitePost: "/checkin/edit-website-post",
  editYoutubePost: "/checkin/edit-youtube-post",
  editTiktokPost: "/checkin/edit-tiktok-post",
  updatePostStatus: "/checkin/update-post-status",
  retryPost: "/checkin/retry-post",
  bulkRetryPost: "/checkin/bulk-retry-post",
  deletePost: "/checkin/delete-post",
  setwidgetpreference: "/checkin/set-widget-preference",
  addonCancelCheckinSubscription: "/addon/cancel-checkin-subscription",
  addonRestoreCheckinSubscription: "/addon/restore-checkin-subscription",
  deleteEmployee: "/checkin-business/delete-employee",
  deleteCheckinBusiness: "/checkin-business/delete-business",
  getPostsPaginated: "/checkin-business/get-posts",
  getPost: "/checkin-business/get-post",
  addonPurchaseAiCredit: "/addon/purchase-ai-credits",
  addonConfirmPurchaseAiCredit: "/addon/confirm-ai-credits-purchase",
  getgmbreviews: "/checkin-business/get-gmb-reviews",
  getReviews: "/review/get-reviews",
  refreshReviews: "/review/refresh-reviews",
  getReviewSummary: "/review/get-summary",
  regenerateReviewSummary: "/review/regenerate-summary",
  replyReview: "/review/reply-review",
  confirmDraft: "/review/confirm-draft",
  toggleAutomation: "/review/toggle-automation",
  getReviewConfig: "/review/get-config",
  updateReviewConfig: "/review/update-config",
  agentsList: "/review/agents-list",
  agentsCreate: "/review/agents-create",
  agentsEdit: "/review/agents-edit",
  agentsDelete: "/review/agents-delete",
  reinviteEmployee: "/checkin-business/reinvite-employee",
  toggleHeatmap: "/heatmap/toggle-heatmap",
  adminToggleHeatmap: "/admin/toggle-heatmap",
  addAllBusiness: "/business/multiple",
  heatmapCompareBusiness: "/heatmap/compare",
  adminHeatmapCompareBusiness: "/admin/compare",
  billingCustomPortal: "/billing/customer-portal",
  billingUpgradePreview: "/billing/preview-upgrade",
  agency: "/agency/agency",
  agencySetup: "/agency/setup",
  agencyUpdate: "/agency/update",
  testEmail: "/agency/test-email",
  validateSMTP: "/agency/validate-smtp",
  agencyVerifyDomain: "/agency/verify-domain",
  agencyTestSMTP: "/agency/test-smtp",
  bridgeExchangeToken: "/auth/exchange-bridge-token",
  authAppleExchangeToken: "/auth/exchange-apple-token",
  exchangeGBPToken: "/auth/exchange-gbp-token",
  exchangeGBPFetchToken: "/auth/exchange-gbp-fetch-token",
  listCheckinBusiness: "/checkin-business/list-gbp-business",
  listCheckinBusinessPaginated: "/checkin-business/list-gbp-business-paginated",
  importCheckinBusiness: "/checkin-business/import-gbp-business",
  sendWidgetInstallEmail: "/checkin-business/send-widget-install-email",
  checkinBusinessCustomerPortal: "/checkin-business/customer-portal",
  checkinBusinessSetupPaymentMethod: "/checkin-business/setup-payment-method",
  checkinBusinessSubscriptionDetails: "/checkin-business/subscription-details",
  facebookExchangeToken: "/auth/exchange-facebook-token",
  instagramExchangeToken: "/auth/exchange-instagram-token",
  youtubeExchangeToken: "/auth/exchange-youtube-token",
  instagramPortfolioExchangeToken: "/auth/exchange-instagram-portfolio-token",
  tiktokExchangeToken: "/checkin-business/exchange-tiktok-token",
  trackerDashboard: "/user/tracker-dashboard",
  checkinDashboard: "/user/checkin-dashboard",
  adminUserListSimplified: "/admin/users-list-simplified",
  adminBusinessListSimplified: "/admin/business-list-simplified",
  exchangeReconnectGBPToken: "/auth/exchange-gbp-reconnect-token",
  reconnectGBPPlatform: "/checkin-business/connect-gbp-location",
  workspaceWidget: "/workspace/widget",
  workspaceReport: "/workspace/widget/reports",
  workspaceWidgetRetryScan: "/workspace/widget/retry-scan",
  workspaceWidgetReportExport: "/workspace/widget/reports/export",
  toggleAdminRole: "/checkin-business/toggle-business-admin",
  listManagedBusiness: "/checkin-business/list-managed-businesses",
  adminUserBypass: "/admin/user-bypass",
  adminWorkspaceDeletePreview: "/admin/workspace-delete/preview",
  adminWorkspaceDelete: "/admin/workspace-delete",
  initiateEject: "/checkin-business/initiate-eject",
  ejectHistory: "/checkin-business/eject-history",
  cancelEject: "/checkin-business/cancel-eject",
  resendEjectEmail: "/checkin-business/resend-eject-email",
  acceptEject: "/public/accept-eject",
  rejectEject: "/public/reject-eject",
  ejectDetails: "/public/eject-details",
  checkUserExists: "/public/eject-check-user",
  workspace: "/workspace",
  switchWorkspace: "/workspace/switch",
  workspaceMembers: "/workspace/members",
  workspaceMembersPaginated: "/workspace/members-paginated",
  workspaceVerifyDomain: "/workspace/verify-domain",
  workspaceTestEmail: "/workspace/test-email",
  workspaceUpdate: "/workspace/update",
  workspaceDetails: "/workspace/details",
  workspaceValidateSMTP: "/workspace/validate-smtp",
  acceptInvite: "/auth/accept-invite",
  validateInvite: "/auth/validate-invite",
  workspaceLocations: "/workspace/locations",
  updateUserProfile: "/user/update-profile",
  uploadProfilePicture: "/user/upload-profile-picture",
  intercomToken: "/user/intercom-token",
  updateWidgetPreferenceIntegration:
    "/checkin-business/update-widget-preference-integration",
  regenerateYoutubeVideo: "/checkin/regenerate-youtube-video",
  regenerateYoutubeAudio: "/checkin/regenerate-youtube-audio",
  regenerateTiktokVideo: "/checkin/regenerate-tiktok-video",
  regenerateTiktokAudio: "/checkin/regenerate-tiktok-audio",
  adminAudioUpload: "/admin/checkin/audio/upload",
  adminAudio: "/admin/checkin/audio",
  listAudio: "/audio",
  adminAudioDefault: "/admin/checkin/audio/default",
  crmImportCrms: "/admin/crm-import/crms",
  crmImportLookupUsers: "/admin/crm-import/lookup/users",
  crmImportLookupBusinessContext: "/admin/crm-import/lookup/businesses",
  crmImportLookupWorkspaces: "/admin/crm-import/lookup/workspaces",
  crmImportJobberConnect: "/admin/crm-import/pull/jobber/connect",
  crmImportPullTest: "/admin/crm-import/pull/test-connection",
  crmImportPullStart: "/admin/crm-import/pull/start",
  crmImportImports: "/admin/crm-import/imports",
  crmImportPushPreview: "/admin/crm-import/push/preview",
  crmImportPush: "/admin/crm-import/push",
  exchangeJobberToken: "/checkin-business/exchange-jobber-token",
  exchangeCompanyCamToken: "/checkin-business/exchange-companycam-token",
  companyCamConfigs: "/checkin-business/companycam-configs",
  disconnectJobber: "/checkin-business/disconnect-jobber",
  jobberConfigs: "/checkin-business/jobber-configs",
  bulkScheduleCheckins: "/checkin/bulk-schedule-checkins",
  generateReviewRequest: "/checkin-business/generate-review-request",
  fetchReviewRequest: "/public/review-request",
  generateQuickReply: "/review/generate-quick-reply",
  checkinBusinessInvoices: "/checkin-business/invoices",
  checkinBusinessTopups: "/checkin-business/topups",
  retryPurchase: "/addon/retry-purchase",
  autoChargeConfig: "/checkin-business/auto-charge-config",
  updateAutoChargeConfig: "/checkin-business/update-auto-charge-config",
  listCreditAlerts: "/checkin-business/credit-alerts",
  addCreditAlert: "/checkin-business/add-credit-alert",
  editCreditAlert: "/checkin-business/edit-credit-alert",
  deleteCreditAlert: "/checkin-business/delete-credit-alert",
  resellingConnectAccount: "/reselling/connect-account",
  resellingAccountStatus: "/reselling/account-status",
  resellingDisconnect: "/reselling/disconnect",
  resellingConfig: "/reselling/config",
  resellingUpdateCheckinConfig: "/reselling/update-checkin-config",
  resellingUpdateCreditConfig: "/reselling/update-credit-config",
  resellingClientsPaginated: "/reselling/clients-paginated",
  resellingOverviewStats: "/reselling/overview-stats",
  resellingDashboardLink: "/reselling/dashboard-link",
  getSetupChecklist: "/checkin-business/setup-checklist",
  setupChecklistMarkDone: "/checkin-business/setup-checklist/mark-done",
  checkinBusinessBillingSummary: "/checkin-business/billing-summary",
  checkinBusinessBillingTable: "/checkin-business/billing-table",
  getSubscriptionDetails: "/billing/subscription-details",
  restoreSubscription: "/billing/restore-subscription",
  getBillingInvoices: "/billing/invoices",
  // Review Widget Routes
  addReviewWidget: "/checkin-widget/add-review-widget",
  editReviewWidget: "/checkin-widget/edit-review-widget",
  getReviewWidgetConfig: "/checkin-widget/get-review-widget-config",
  getReviewWidgetList: "/checkin-widget/get-review-widget-list",
  getReviewWidgetDetail: "/checkin-widget/get-review-widget-detail",
  getReviewWidgetJsonld: "/checkin-widget/get-review-widget-jsonld",
  regenerateReviewWidgetSummary: "/checkin-widget/regenerate-review-widget-summary",
  // Photo Gallery Widget Routes
  addPhotoGalleryWidget: "/checkin-widget/add-photo-gallery-widget",
  editPhotoGalleryWidget: "/checkin-widget/edit-photo-gallery-widget",
  getPhotoGalleryWidgetConfig: "/checkin-widget/get-photo-gallery-widget-config",
  getPhotoGalleryWidgetList: "/checkin-widget/get-photo-gallery-widget-list",
  getPhotoGalleryWidgetJsonld: "/checkin-widget/get-photo-gallery-widget-jsonld",
  addPostImage: "/checkin-widget/add-post-image",
  // Report Builder Routes
  reportBuilder: "/report-builder",
  reportBuilderEligible: "/report-builder/eligible-businesses",
  reportBuilderSyncRankBusinesses: "/report-builder/sync-rank-businesses",
  reportBuilderBulkDelete: "/report-builder/bulk-delete",
  reportBuilderBulkSchedule: "/report-builder/bulk-schedule",
  reportBuilderBulkSend: "/report-builder/bulk-send",
  reportBuilderAiSummary: "/report-builder/ai-summary",
  reportBuilderAiSummaryRefresh: "/report-builder/ai-summary/refresh",
  reportBuilderById: (id: string) => `/report-builder/${id}`,
  reportBuilderData: (id: string) => `/report-builder/${id}/data`,
  reportBuilderRankScans: (id: string) => `/report-builder/${id}/rank/scans`,
  reportBuilderRankCompare: (id: string) => `/report-builder/${id}/rank/compare`,
  reportBuilderEmailSchedule: (id: string) => `/report-builder/${id}/email-schedule`,
  reportBuilderSend: (id: string) => `/report-builder/${id}/send`,
  reportBuilderAssignees: (id: string) => `/report-builder/${id}/assignees`,
  reportBuilderEmbedMeta: (id: string) => `/report-builder/${id}/embed-meta`,
  publicReportBuilder: (id: string) => `/public/report-builder/${id}`,
  publicReportBuilderRankCompare: (id: string) => `/public/report-builder/${id}/rank/compare`,
  publicReportBuilderTask: (id: string, taskId: string) => `/public/report-builder/${id}/tasks/${taskId}`,
};
